class SliderComponent extends HTMLElement {
    constructor() {
        if (
            (super(),
            (this.slider = this.querySelector("ul")),
            (this.sliderItems = this.querySelectorAll("li")),
            (this.pageCount = this.querySelector(".slider-counter--current")),
            (this.pageTotal = this.querySelector(".slider-counter--total")),
            (this.prevButton = this.querySelector('button[name="previous"]')),
            (this.nextButton = this.querySelector('button[name="next"]')),
            (this.dotButton = this.querySelectorAll('button[name="dots"]')),
            (this.rtl_num = document.body.classList.contains("layout_rtl") ? -1 : 1),
            !this.slider || !this.nextButton)
        )
            return;
        new ResizeObserver((t) => this.initPages()).observe(this.slider),
            this.slider.addEventListener("scroll", this.update.bind(this)),
            this.prevButton.addEventListener("click", this.onButtonClick.bind(this)),
            this.nextButton.addEventListener("click", this.onButtonClick.bind(this)),
            this.dotButton.forEach((t) => {
                t.addEventListener("click", this.onDotClick.bind(this));
            });
    }
    initPages() {
        0 !== this.sliderItems.length &&
            ((this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth)),
            (this.totalPages = this.sliderItems.length - this.slidesPerPage + 1),
            this.pageCount && (this.pageCount.innerText = this.slidesPerPage));
    }
    update() {
        (this.currentPage = Math.round((this.slider.scrollLeft / this.sliderItems[0].clientWidth) * this.rtl_num)),
            this.querySelector(".dots-item.active")?.classList.remove("active"),
            this.querySelectorAll(".dots-item")[this.currentPage]?.classList.add("active"),
            this.pageCount && (this.pageCount.innerText = this.slidesPerPage + this.currentPage);
    }
    onButtonClick(t) {
        t.preventDefault();
        const e =
            "next" === t.currentTarget.name
                ? this.slider.scrollLeft + this.sliderItems[0].clientWidth * this.rtl_num
                : this.slider.scrollLeft - this.sliderItems[0].clientWidth * this.rtl_num;
        this.slider.scrollTo({ left: e });
    }
    onDotClick(t) {
        t.preventDefault(), (this.dotActive = this.querySelector(".dots-item.active button"));
        this.dotActive.dataset.index;
        const e = t.currentTarget.dataset.index;
        this.querySelector(".dots-item.active").classList.remove("active"),
            t.currentTarget.closest(".dots-item").classList.add("active");
        const s = e * this.sliderItems[0].clientWidth;
        this.slider.scrollTo({ left: s });
    }
}
customElements.define("slider-component", SliderComponent);
class ProductSliderComponent extends SliderComponent {
    constructor() {
        if (
            (super(),
            (this.slider = this.querySelector(".slider")),
            (this.sliderItems = this.querySelectorAll(".slider__slide")),
            0 === this.sliderItems.length && (this.sliderItems = this.querySelectorAll(".slider div.product")),
            !this.slider || !this.nextButton)
        )
            return;
        new ResizeObserver((t) => this.initPages()).observe(this.slider);
        new MutationObserver(() => {
            (this.slider = this.querySelector(".slider")),
                (this.sliderItems = this.querySelectorAll(".slider__slide").length
                    ? this.querySelectorAll(".slider__slide")
                    : this.querySelectorAll(".slider div.product")),
                this.slider.addEventListener("scroll", this.update.bind(this)),
                this.prevButton?.addEventListener("click", this.onButtonClick.bind(this)),
                this.nextButton?.addEventListener("click", this.onButtonClick.bind(this)),
                this.dotButton.forEach((t) => {
                    t.addEventListener("click", this.onDotClick.bind(this));
                });
        }).observe(this.slider, { subtree: !0, childList: !0 }),
            this.slider.addEventListener("scroll", this.update.bind(this)),
            this.prevButton?.addEventListener("click", this.onButtonClick.bind(this)),
            this.nextButton?.addEventListener("click", this.onButtonClick.bind(this)),
            this.dotButton.forEach((t) => {
                t.addEventListener("click", this.onDotClick.bind(this));
            });
    }
}
class BannerSliderComponent extends SliderComponent {
    constructor() {
        if (
            (super(),
            (this.slider = this.querySelector(".slider")),
            (this.sliderItems = this.querySelectorAll(".slider__slide")),
            !this.slider || !this.dotButton)
        )
            return;
        new ResizeObserver((t) => this.initPages()).observe(this.slider);
        new MutationObserver(() => {
            (this.slider = this.querySelector(".slider")),
                (this.sliderItems = this.querySelectorAll(".slider__slide")),
                this.slider.addEventListener("scroll", this.update.bind(this)),
                this.prevButton?.addEventListener("click", this.onButtonClick.bind(this)),
                this.nextButton?.addEventListener("click", this.onButtonClick.bind(this)),
                this.dotButton.forEach((t) => {
                    t.addEventListener("click", this.onDotClick.bind(this));
                });
        }).observe(this.slider, { subtree: !0, childList: !0 }),
            this.slider.addEventListener("scroll", this.update.bind(this)),
            this.prevButton?.addEventListener("click", this.onButtonClick.bind(this)),
            this.nextButton?.addEventListener("click", this.onButtonClick.bind(this)),
            this.dotButton.forEach((t) => {
                t.addEventListener("click", this.onDotClick.bind(this));
            }),
            this.initButtonDisable();
    }
    initButtonDisable() {
        const t = new IntersectionObserver(
            (t) => {
                t.forEach((t) => {
                    t.isIntersecting
                        ? t.target.classList.contains("first-item")
                            ? this.prevButton?.classList.add("disabled")
                            : t.target.classList.contains("last-item") && this.nextButton?.classList.add("disabled")
                        : t.target.classList.contains("first-item")
                          ? this.prevButton?.classList.remove("disabled")
                          : t.target.classList.contains("last-item") && this.nextButton?.classList.remove("disabled");
                });
            },
            { threshold: 0.8, root: this.slider }
        );
        this.sliderItems[0].classList.add("first-item"),
            this.sliderItems[this.sliderItems.length - 1].classList.add("last-item"),
            t.observe(this.sliderItems[0]),
            t.observe(this.sliderItems[this.sliderItems.length - 1]);
    }
}
class TiktokSliderComponent extends BannerSliderComponent {
    constructor() {
        super(), (this.sliderActionsAndPageCount = this.querySelector(".slider-buttons"));
    }
    initPages() {
        if (0 === this.sliderItems.length) return;
        const t = this.slider.clientWidth / this.sliderItems[0].clientWidth;
        (this.slidesPerPage = t % 1 > 0.5 ? Math.ceil(t) : Math.floor(t)),
            (this.totalPages = Math.ceil(this.sliderItems.length - this.slidesPerPage) + 1),
            this.pageTotal && "true" === this.dataset.tiktokSlider && (this.pageTotal.innerText = this.totalPages),
            this.totalPages <= 1 || window.innerWidth >= 1025
                ? (this.sliderActionsAndPageCount.style.display = "none")
                : this.totalPages > 1 && (this.sliderActionsAndPageCount.style.display = "flex");
    }
}
window.addEventListener("load", () => {
    customElements.define("banner-slider-component", BannerSliderComponent),
        customElements.define("product-slider-component", ProductSliderComponent),
        customElements.define("tiktok-slider-component", TiktokSliderComponent);
});
